import { defineComponent as _defineComponent } from 'vue'
import TTDeletedPageDetailsModal from "@/components/modules/bet-details/TTDeletedPageDetailsModal.vue";
import UserBreadcrumb from "@/components/common/UserBreadcrumb.vue";
import { queries } from "@/apollo";
import { DeletedTtPage, User } from "@/CodegenTypes";

import { sumBy, startCase, first } from "lodash";
import { formatCount } from "@/helpers/formatCount";
import AccountSelectModal from "@/components/modules/account/AccountSelectModal.vue";
import AccountSelectSearch from "@/components/modules/account/AccountSelectSearch.vue";
import { customMoment } from "@/main";
import { useTranslation } from "@/store/translation";
import { computed, ref } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useRoute } from "vue-router/composables";

type RouteQueryValue = string | (string | null)[] | null | undefined;


export default /*#__PURE__*/_defineComponent({
  __name: 'TTDeletedBetDetails',
  setup(__props) {

const route = useRoute();
const { $t } = useTranslation();
const t = (text: string) => $t(text);

const showAccountSelectionModal = ref(false);
const selectedPage = ref<null | DeletedTtPage>(null);
const showPageDetailModal = ref(false);

const selectedStartReleaseDate = computed(() =>
  getRouteQueryValue(route.query.startReleaseDate)
);
const selectedUserId = computed(() => getRouteQueryValue(route.query.userId));
const userDeletedTtPagesVariables = computed(() => {
  return {
    releaseDate: customMoment(selectedStartReleaseDate.value)
      .startOf("day")
      .toDate(),
    behalfOf: selectedUserId.value,
  };
});

const { result: userDeletedTtPagesResult, loading: apolloLoading } = useQuery<{
  user: User;
}>(queries.userDeletedTtPages, userDeletedTtPagesVariables, {
  enabled: computed(() => !!selectedStartReleaseDate.value),
  fetchPolicy: "cache-and-network",
});

const user = computed(() => userDeletedTtPagesResult.value?.user ?? null);
const pageDetailsData = computed(() => {
  const currUser = user.value;
  if (!currUser) {
    return [];
  }

  const downlinesData = currUser.deletedTtPages
    .map((page) => {
      const unit = page.calculation.unit;

      return {
        ...page,
        upline: page.userId,
        uplineName: page.username,
        account: page.userId,
        username: page.username,
        unit,
        createdAt: page.createdAt,
      };
    })
    .filter((u) => u.unit > 0)
    .sort(
      (u1, u2) =>
        customMoment(u1.createdAt).unix() - customMoment(u2.createdAt).unix()
    )
    .sort((u1, u2) => u1.upline.localeCompare(u2.upline));

  return downlinesData.map((row) => {
    return {
      ...row,
      uplineCount: downlinesData.filter((d) => d.upline === row.upline).length,
      accountCount: downlinesData.filter((d) => d.account === row.account)
        .length,
    };
  });
});
const pageDetailTotal = computed(() => {
  const data = pageDetailsData.value;
  return {
    unit: sumBy(data, (d) => d.unit).toFixed(2),
  };
});

function getRouteQueryValue(query: RouteQueryValue) {
  return Array.isArray(query) ? first(query) : query;
}

function rowTestId(value: string) {
  return String(value || "unknown")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

function formatDate(dateStr: string) {
  return customMoment(dateStr).format("ddd, DD/MM/YYYY hh:mm:ss A");
}

function viewPageDetails(id: DeletedTtPage["id"]) {
  const page = pageDetailsData.value.find((p) => p.id === id);
  if (!page) {
    return;
  }
  selectedPage.value = page;
  showPageDetailModal.value = true;
}

return { __sfc: true,route, $t, t, showAccountSelectionModal, selectedPage, showPageDetailModal, selectedStartReleaseDate, selectedUserId, userDeletedTtPagesVariables, userDeletedTtPagesResult, apolloLoading, user, pageDetailsData, pageDetailTotal, getRouteQueryValue, rowTestId, formatDate, viewPageDetails, TTDeletedPageDetailsModal, UserBreadcrumb, startCase, formatCount, AccountSelectModal, AccountSelectSearch }
}

})